import { Session } from '@appclose/lib';

export const publicSession = new Session({
  accessTokenKey: 'PUBLIC_AUTHORIZATION_TOKEN',
  refreshTokenKey: null,
  storage: 'sessionStorage',
});
